import './Footer.css';

const Footer = () => {
    return (
        <footer className='footer'>
            <p>Desenvolvido com ❤️ por <a href='https://github.com/burigooth' target='_blank' rel="noreferrer">Mateus</a></p>      
        </footer>
    );
};

export default Footer;